var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-content"},[_vm._m(0),_c('div',{staticClass:"error-message"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-icon"},[_c('img',{attrs:{"src":require("@/assets/pc/fork_red.svg"),"alt":"错误"}})])
}]

export { render, staticRenderFns }